import { COMMON_CONSTANT } from 'model/constants/actionConstants';

const initState = {
	notice: {
		isShow: false,
		type: null,
		msg: null,
	},
};

export default (state = initState, action) => {
	switch (action.type) {
		case COMMON_CONSTANT.SET_NOTICE:
			return { ...state, notice: action.payload };
		case COMMON_CONSTANT.CLOSE_NOTICE:
			return { ...state, notice: action.payload };
		default:
			return state;
	}
};
